<template>
    <div class="bg">
        <img src="@/assets/home/bgLeft.png" alt="" class="bgLeft">
        <img src="@/assets/home/bgRight.png" alt="" class="bgRight">
     <div class="page animate__animated  animate__fadeIn">
         <div class="dynamic">
             <div class="title">
                 NEWS
                 <h1>公司动态</h1>
                 <div>
                     <i></i> <i></i>
                 </div>
             </div>
             <div>
                 <ul>
                     <li>
                         <div>
                             <i></i>
                             <p>南京中禹智慧水利研究院有限公司战略合作协议签订</p>
                             <p>2023/12/28</p></div>
                     </li>
                     <li>
                         <div>
                             <i></i>
                             <p>南京中禹智慧水利研究院有限公司战略合作协议签订</p>
                             <p>2023/12/28</p></div>
                     </li>
                     <li>
                         <div>
                             <i></i>
                             <p>南京中禹智慧水利研究院有限公司战略合作协议签订</p>
                             <p>2023/12/28</p></div>
                     </li>
                     <li>
                         <div>
                             <i></i>
                             <p>南京中禹智慧水利研究院有限公司战略合作协议签订</p>
                             <p>2023/12/28</p></div>
                     </li>
                     <li>
                         <div>
                             <i></i>
                             <p>南京中禹智慧水利研究院有限公司战略合作协议签订</p>
                             <p>2023/12/28</p></div>
                     </li>


                 </ul>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
export default {
    name: "News",
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
</script>

<style scoped lang="less">
@import "../styles/news";


</style>
